import {useState,useEffect, useContext} from 'react';
import useFetch from '../../../Components/APIs/FetchAlbums';
import IsLoading from '../../../Components/isLoading.js';
import Button from '@mui/material/Button';
import {Link, useParams, useNavigate} from 'react-router-dom';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import IconButton from '@mui/material/IconButton';
import NavigationMenuToggle from '../../../Components/Navigation/NavigationMenuToggle.js';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { GeneralFunctionsContext } from '../../../Components/Contexts/GeneralFunctionsContext';
const Container = (props) => {
    const {innerWidth, offset} = useContext(GeneralFunctionsContext);
    

    const navigate = useNavigate();

    const {album_id} = useParams();


    const [request, setRequest] = useState(null)
    const {data:FetchedData,isLoading, error} = useFetch(request)

    useEffect(()=>{
        if(FetchedData && FetchedData.total_results>0){
            navigate('/playing/'+FetchedData.results[0].songs[0].song.song_id+"?&tab=2", {replace: true})
        }
    },[FetchedData])


    const send_request =()=>{
        setRequest({
            "search_string": "",
            "genre": "",
            "album_id": album_id,
            "user_id": "",
            "genre": "",
            "sort": "newest",
            "page":1,
        })
    }



    useEffect(()=>{
        send_request()
    },[])

 


  return (
    <>
    <div className="navbar">
        <div className="wrapper">
            <div className="lft">
                <Link to="/">
                    <svg className="brandlogo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 343.499 89.722">
                        <path id="Logo" d="M31.4,64.608A31.436,31.436,0,1,1,62.835,33.173,31.436,31.436,0,0,1,31.4,64.608Zm.07-58.871A27.436,27.436,0,1,0,58.835,33.173,27.467,27.467,0,0,0,31.47,5.737ZM74,91.459A15.718,15.718,0,1,1,89.721,75.741,15.718,15.718,0,0,1,74,91.459Zm.035-29.436A13.718,13.718,0,1,0,87.721,75.741,13.734,13.734,0,0,0,74.038,62.023Zm42.876,2.826H109.05v7.886h-1.425V55.873h10.447v1.2H109.05v6.567h7.864Zm16.514.37a9.741,9.741,0,0,1-.8,4.089,6.147,6.147,0,0,1-2.3,2.71,6.3,6.3,0,0,1-3.451.949,5.988,5.988,0,0,1-4.771-2.113,8.455,8.455,0,0,1-1.818-5.7V63.412a9.69,9.69,0,0,1,.816-4.082,6.455,6.455,0,0,1,9.184-2.75,6.166,6.166,0,0,1,2.3,2.651,9.552,9.552,0,0,1,.845,3.973ZM132,63.39a7.451,7.451,0,0,0-1.379-4.772,4.956,4.956,0,0,0-7.521.006,7.508,7.508,0,0,0-1.4,4.835v1.76a7.452,7.452,0,0,0,1.39,4.755,4.961,4.961,0,0,0,7.551.022A7.651,7.651,0,0,0,132,65.173Zm11.315,2.316h-4.9v7.029h-1.436V55.873h5.478a6.248,6.248,0,0,1,4.215,1.308,4.989,4.989,0,0,1,.568,6.511A4.853,4.853,0,0,1,144.7,65.4l4.216,7.18v.15H147.4Zm-4.9-1.205h4.366a4.044,4.044,0,0,0,2.884-1.021,3.857,3.857,0,0,0-.046-5.417,4.707,4.707,0,0,0-3.186-.985H138.42Zm22.537,3.683.521,2.618.637-2.5,3.659-12.427h1.286L170.673,68.3l.626,2.524.555-2.64L174.9,55.873h1.459L172.04,72.735h-1.367l-3.821-13.19-.429-1.668-.417,1.668-3.914,13.19h-1.367l-4.308-16.862h1.459ZM187.709,68h-7.654l-1.739,4.736h-1.493L183.2,55.873h1.355l6.381,16.862h-1.482Zm-7.215-1.205h6.764l-3.382-9.184Zm19.225-1.088h-4.9v7.029h-1.436V55.873h5.478a6.253,6.253,0,0,1,4.216,1.308,4.989,4.989,0,0,1,.568,6.511A4.857,4.857,0,0,1,201.1,65.4l4.214,7.18v.15H203.8Zm-4.9-1.205h4.367a4.041,4.041,0,0,0,2.883-1.021,3.853,3.853,0,0,0-.047-5.417,4.7,4.7,0,0,0-3.184-.985H194.82Zm19.953,1.205h-4.9v7.029h-1.437V55.873h5.479a6.253,6.253,0,0,1,4.216,1.308,4.99,4.99,0,0,1,.567,6.511,4.853,4.853,0,0,1-2.548,1.713l4.215,7.18v.15h-1.516Zm-4.9-1.205h4.366a4.045,4.045,0,0,0,2.884-1.021,3.853,3.853,0,0,0-.047-5.417,4.7,4.7,0,0,0-3.184-.985h-4.019Zm15.392,8.234h-1.425V55.873h1.425ZM242.3,65.219a9.741,9.741,0,0,1-.805,4.089,6.141,6.141,0,0,1-2.3,2.71,6.3,6.3,0,0,1-3.451.949,5.987,5.987,0,0,1-4.771-2.113,8.456,8.456,0,0,1-1.819-5.7V63.412a9.69,9.69,0,0,1,.817-4.082,6.455,6.455,0,0,1,9.184-2.75,6.172,6.172,0,0,1,2.3,2.651A9.552,9.552,0,0,1,242.3,63.2Zm-1.424-1.829a7.457,7.457,0,0,0-1.378-4.772,4.957,4.957,0,0,0-7.522.006,7.508,7.508,0,0,0-1.4,4.835v1.76a7.452,7.452,0,0,0,1.39,4.755,4.96,4.96,0,0,0,7.55.022,7.645,7.645,0,0,0,1.356-4.823Zm11.314,2.316h-4.9v7.029h-1.437V55.873h5.479a6.253,6.253,0,0,1,4.216,1.308,4.99,4.99,0,0,1,.567,6.511,4.853,4.853,0,0,1-2.548,1.713l4.215,7.18v.15H256.27Zm-4.9-1.205h4.366a4.045,4.045,0,0,0,2.884-1.021,3.853,3.853,0,0,0-.047-5.417,4.7,4.7,0,0,0-3.185-.985h-4.018Zm23.2,4.088a2.731,2.731,0,0,0-.984-2.218,10.422,10.422,0,0,0-3.6-1.552,12.621,12.621,0,0,1-3.822-1.6,3.89,3.89,0,0,1-.121-6.364,6.535,6.535,0,0,1,4.07-1.21,6.751,6.751,0,0,1,3.006.648,4.928,4.928,0,0,1,2.056,1.807,4.746,4.746,0,0,1,.729,2.583h-1.436a3.546,3.546,0,0,0-1.181-2.783,4.6,4.6,0,0,0-3.174-1.051,5,5,0,0,0-3.08.864,2.694,2.694,0,0,0-1.146,2.256,2.548,2.548,0,0,0,1.03,2.1,9.521,9.521,0,0,0,3.3,1.433,15.544,15.544,0,0,1,3.439,1.287,4.919,4.919,0,0,1,1.761,1.592,3.993,3.993,0,0,1,.59,2.189,3.812,3.812,0,0,1-1.592,3.2,6.789,6.789,0,0,1-4.2,1.2,8.221,8.221,0,0,1-3.272-.637,5.007,5.007,0,0,1-2.259-1.783,4.609,4.609,0,0,1-.769-2.629h1.424a3.364,3.364,0,0,0,1.332,2.813,5.63,5.63,0,0,0,3.544,1.032,5.252,5.252,0,0,0,3.161-.869A2.715,2.715,0,0,0,270.491,68.589ZM125.924,38.765a8.893,8.893,0,0,1-3.911,2.571,16.394,16.394,0,0,1-5.6.914,11.1,11.1,0,0,1-5.662-1.409,9.4,9.4,0,0,1-3.758-4.091,14.4,14.4,0,0,1-1.358-6.3V28.756a15.291,15.291,0,0,1,1.255-6.448,9.294,9.294,0,0,1,3.621-4.168,11.923,11.923,0,0,1,12.461.667,9.014,9.014,0,0,1,2.955,6.14h-4.987a4.966,4.966,0,0,0-1.512-3.126,4.832,4.832,0,0,0-3.22-.99,4.543,4.543,0,0,0-3.98,1.964,10.324,10.324,0,0,0-1.383,5.841v1.589a9.829,9.829,0,0,0,1.486,5.91,5.087,5.087,0,0,0,4.355,2q2.886,0,4.117-1.23V32.616h-4.663V28.841h9.787Zm19.113-7.635H135.2v6.662h11.547v4.116H130.075V17.039h16.636v4.15H135.2v5.927h9.838Zm24.939,10.778h-5.125l-9.975-16.363V41.908h-5.124V17.039h5.124l9.992,16.4v-16.4h5.108Zm9.923,0h-5.124V17.039H179.9Zm23.572-24.869v16.38a8.388,8.388,0,0,1-2.553,6.456,9.848,9.848,0,0,1-6.979,2.375,9.96,9.96,0,0,1-6.918-2.306,8.25,8.25,0,0,1-2.613-6.337V17.039h5.125V33.453a4.74,4.74,0,0,0,1.17,3.562,4.488,4.488,0,0,0,3.236,1.118q4.322,0,4.391-4.543V17.039Zm13.1,8.574,4.663-8.574h5.894l-7.242,12.332,7.429,12.537h-5.961L216.571,33.2l-4.782,8.711h-5.961l7.43-12.537-7.242-12.332h5.893ZM245.3,17.039l6.388,18.037,6.354-18.037h6.73V41.908h-5.141v-6.8l.513-11.735-6.713,18.533h-3.519l-6.7-18.515.512,11.717v6.8h-5.124V17.039Zm42.77,0v16.38a8.384,8.384,0,0,1-2.553,6.456,9.849,9.849,0,0,1-6.978,2.375,9.957,9.957,0,0,1-6.918-2.306,8.243,8.243,0,0,1-2.613-6.337V17.039h5.124V33.453a4.736,4.736,0,0,0,1.17,3.562,4.491,4.491,0,0,0,3.237,1.118q4.322,0,4.39-4.543V17.039Zm17.1,18.344a2.633,2.633,0,0,0-1.024-2.229,13.47,13.47,0,0,0-3.69-1.639,26.243,26.243,0,0,1-4.219-1.7Q292,27.526,292,23.649a6,6,0,0,1,1.136-3.6,7.406,7.406,0,0,1,3.262-2.468,12.283,12.283,0,0,1,4.774-.888,11.185,11.185,0,0,1,4.749.965,7.566,7.566,0,0,1,3.236,2.724,7.131,7.131,0,0,1,1.154,4h-5.125a3.356,3.356,0,0,0-1.076-2.656,4.422,4.422,0,0,0-3.023-.948,4.721,4.721,0,0,0-2.921.8,2.506,2.506,0,0,0-1.042,2.092,2.4,2.4,0,0,0,1.222,2.033,13.819,13.819,0,0,0,3.6,1.537,15.55,15.55,0,0,1,6.371,3.262,6.5,6.5,0,0,1,2,4.851,5.989,5.989,0,0,1-2.443,5.065,10.694,10.694,0,0,1-6.576,1.836,12.691,12.691,0,0,1-5.227-1.051,8.262,8.262,0,0,1-3.6-2.878,7.366,7.366,0,0,1-1.239-4.236h5.142q0,4.118,4.919,4.117a4.785,4.785,0,0,0,2.853-.744A2.419,2.419,0,0,0,305.17,35.383Zm14.057,6.525H314.1V17.039h5.124ZM343.5,33.624a8.8,8.8,0,0,1-2.964,6.32,10.41,10.41,0,0,1-7.046,2.306,9.358,9.358,0,0,1-7.524-3.22q-2.74-3.219-2.741-8.839V28.67a14.9,14.9,0,0,1,1.264-6.319,9.465,9.465,0,0,1,3.613-4.194A11.289,11.289,0,0,1,340.492,19a9.454,9.454,0,0,1,3.041,6.474h-5.125a5.19,5.19,0,0,0-1.341-3.494,4.962,4.962,0,0,0-3.509-1.084,4.354,4.354,0,0,0-3.835,1.836q-1.272,1.836-1.307,5.7v1.879q0,4.031,1.222,5.892a4.272,4.272,0,0,0,3.851,1.862,5.052,5.052,0,0,0,3.544-1.085,4.893,4.893,0,0,0,1.341-3.356Z" transform="translate(-0.034 -1.737)" fill="#fff"/>
                    </svg>
                </Link>
            </div>
            <div className="rgt">
            <NavigationMenuToggle/>
            </div>  
        </div>
    </div>
    <div className="mycontainer">
        <div className='wrapper'>
        
            {(isLoading) &&(<IsLoading/>)}
        

            {/* Feedbacks */}
            {(error=="network_err") &&(
                <div className='wrapper'>
                    <div className="no_data_msg">
                        <div className="container">
                            <div className="icon">
                                <img src="/assets/images/no_album_results.svg" />
                            </div>
                            <p>Check your internet connectivity</p> 
                            <Button onClick={()=>send_request()}>
                                Retry
                            </Button>
                        </div>

                    </div>
                </div> 
            )}  

            {(FetchedData && FetchedData.total_results<1) &&(
                <>
                 {/* {innerWidth>992 &&(
                    <div className="mypath">
                        <div className="wrapper">
                            <div className="lft">
                                {window.history.length>1?
                                <Button onClick={()=>navigate(-1)}>
                                    <KeyboardBackspaceIcon/>
                                </Button>  
                                :
                                <Button onClick={()=>navigate(-1)} disabled="true">
                                    <KeyboardBackspaceIcon/>
                                </Button>  
                                }
                            </div>
                            <div className="rgt">
                                <p>
                                    <Link to="" className="active">MUSIC PLAYER</Link>
                                    <Link to="" className="">{album_id}</Link>
                                </p>
                                
                            </div>
                        </div>
                    </div>
                )} */}
                <div className='wrapper'>
                    <div className="no_data_msg">
                        <div className="container">
                            <div className="icon">
                                <img src="/assets/images/no_album_results.svg" />
                            </div>
                            <p>Album not found or link might be broken.</p> 
                            <Button onClick={()=>send_request()}>
                                Retry
                            </Button>
                        </div>

                    </div>
                </div> 
                </>
            )}   
         </div>
    </div>
    </>
  )
}

export default Container